export default {
  addcomment: 'הוסף תגובה',
  notification: {
    title: 'ההערה נוצרה בהצלחה',
    message: 'הפרטים עודכנו',
    errortitle: 'שגיאה',
    error: 'לא בוצעה יצירת הערה, אנא בדוק את הפרטים שהוזנו',
  },
};
